export default __webpack_public_path__ + "static/media/fMaltoBuza38.2b160b65.png";